import { useCallback } from 'react';
import { UseFilterSavingProps } from '../types';
import { getFiltersForUser, setFiltersForUser } from '../../../utils/filtersStorage';

export const useFilterSaving = ({
  pendingFiltersToSave,
  isEvidence,
  tab,
  view,
  source,
  searchItems,
  user,
  setAlertMessage,
  setShowCopiedAlert,
  setShowFiltersModal,
}: UseFilterSavingProps) => {
  const handleSaveFilters = useCallback(() => {
    if (!pendingFiltersToSave) return;

    const existingFilters = getFiltersForUser(user);

    const searchContext = {
      id: `search-${Date.now()}`,
      tab,
      view,
      source,
      idents: searchItems ? searchItems.map((item: any) => item.id).join('-') : '',
      identsNames: searchItems ? searchItems.map((item: any) => item.name).join(', ') : '',
      isEvidence,
      filters: pendingFiltersToSave,
      savedAt: new Date().toISOString(),
    };

    const updatedFilters = [...existingFilters, searchContext];

    setFiltersForUser(user, updatedFilters);

    setAlertMessage('Filters saved successfully');
    setShowCopiedAlert(true);
    setTimeout(() => setShowCopiedAlert(false), 3000);
    setShowFiltersModal(false);
  }, [
    pendingFiltersToSave,
    isEvidence,
    tab,
    view,
    source,
    searchItems,
    user,
    setAlertMessage,
    setShowCopiedAlert,
    setShowFiltersModal,
  ]);

  return {
    handleSaveFilters,
  };
};